import React from 'react'
import { Person } from 'scenes/Dashboard/data/people/types'

import { Typography } from '@mui/material'

export default class PersonModalHeader extends React.PureComponent<any> {
  render() {
    const { person } = this.props
    if (person) {
      if (person.id) {
        return (
          <Typography variant="h5">
            {person.firstName} {person.lastName}
          </Typography>
        )
      } else {
        return <Typography variant="h5">Add person</Typography>
      }
    } else {
      return <Typography variant="h5">Loading</Typography>
    }
  }
}

export type PersonModalHeaderProps = {
  person: Person
}
